import { AxiosPromise, AxiosError } from 'axios';
export { AxiosError };

export const makeCodedException = async <T>(request: AxiosPromise<T>) => {
    try {
        const resp = await request;

        /*
         * needed to catch non-json responses
         * when proxying to main app is not configured, this requests will be handled by regular frontend deployment
         * so it will return 200 OK with regular html
         */
        if (!resp.headers['content-type']?.includes('application/json')) {
            return Promise.reject(new Error());
        }

        return resp;
    } catch (e) {
        const error = e as AxiosError<ExceptionResponse>;
        if (error.response) {
            // enforce ExceptionResponse structure onto error.response.data
            error.response.data.Error = <ExceptionData>error.response.data.Error || {};
        }
        return Promise.reject(error);
    }
};

export const makeContent = () => {};

export interface ExceptionResponse {
    Error: ExceptionData;
}

export interface ExceptionData {
    Message: string;
    Code?: string | undefined;
    FieldErrors?: { [key: string]: string } | undefined;
}
